import { useActionState, useEffect, useState } from "react";
import { GreetingOccasionSubcategory } from "../../../../models";
import { Button } from "../../../../components/button";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import GreetingOccasionSubcategoryService from "../../../../services/GreetingOccasionSubcategoryService";
import toast from "react-hot-toast";
import IconButton from "../../../../components/icon-button";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { updateGreetingOccasionSubCategory } from "../actions/GreetingOccasionSubcategory";
import { State } from "../actions";
import FormError from "../../../../components/form-error";
import { useNavigate } from "react-router-dom";

export default function GreetingOccasionSubcategoryUpdateForm({item, onCancel}:{item:GreetingOccasionSubcategory, onCancel:()=>void}){
    const [name, setName] = useState(item.name || "");
    const navigate = useNavigate();
    const api = new GreetingOccasionSubcategoryService();
    const initialState: State = {
        message: null,
        success: false,
        errors: {},
        defaultValues: {
            name: item.name || "",
        },
    };
    const updateGreetingOccasionSubcategoryWithId = updateGreetingOccasionSubCategory.bind(null, item.id!);
    const [state, formAction, isPending] = useActionState(
        updateGreetingOccasionSubcategoryWithId,
        initialState
      );

      useEffect(() => {
        console.log({state})
        if (state.success) {
          toast.success("Greeting occasion subcategory updated successfully");
          navigate(`/admin/greeting-occasion-categories/edit/${item.greetingOccasionCategoryId}?reload=${Date.now()}`);
            onCancel();
        }
      }, [state.success]);
    

    return (<>
    <td colSpan={2}  className="px-6 py-4 bg-gray-100">
        <form action={formAction} className="flex gap-2 items-end">
            <div className="flex-1">                
                <Input
                    id="name"
                    name="name"
                    type="text"
                    value={name}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                    placeholder="Enter subcategory name"
                    required
                />
                <input
                    type="hidden"
                    id="greetingOccasionCategoryId"
                    name="greetingOccasionCategoryId"
                    value={item.greetingOccasionCategoryId}
                />
            </div>
            <IconButton label="Update Greeting Occasion Subcategory" icon={CheckIcon} loading={isPending}></IconButton>
            <IconButton type="button" label="Cancel" icon={XMarkIcon} onClick={onCancel}   ></IconButton>
        </form>
        <FormError id="name-error" message={state.errors?.name} />
        </td>
        </>
    );
}
